import React, { FC } from "react";
import { StatusMessage } from "./StatusMessage";
import { StatusRendererProps } from "../../../components/Overlay";

export const FootballStatusRenderer: FC<StatusRendererProps> = ({
  message,
  side,
  homeTeam,
  awayTeam,
  normalizedCode,
  activeTeam,
  status,
  language,
  Icon,
  description,
  width,
  height,
}) => {
  return (
    <>
      {normalizedCode && (
        <StatusMessage
          title={message}
          normalizedCode={normalizedCode}
          team={activeTeam}
          side={side}
          Icon={Icon}
          status={status}
          width={width}
          height={height}
        />
      )}
    </>
  );
};
